import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('plaid_link_token', {
  use_team_settings: '',
  products: '',
  item_id: '',
  link_token_response: '',
})
